<template>
  <div>
    <vx-card v-if="orgData && orgData._id" class="org-card">
      <vs-tabs 
        v-model="activeTab" 
        :position="isSmallerScreen ? 'top' : 'left'" 
        class="tabs-shadow-none" 
        id="profile-tabs"
        :key="isSmallerScreen"
      >
        <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Account' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-account />
          </div>
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Administration' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-admins />
          </div>
        </vs-tab>
        
        <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Configuration' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-config />
          </div>
        </vs-tab>
        
        <vs-tab icon-pack="feather" icon="icon-trending-up" :label="!isSmallerScreen ? 'Evaluation' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-evaluate 
              ref="evaluatePage" 
              @dirty-state-changed="handleDirtyStateChanged"
              @proceed-to-tab="handleProceedToTab"
            />
          </div>
        </vs-tab>

        <!-- NEW: Documents / Pitch Deck Tab -->
        <vs-tab icon-pack="feather" icon="icon-file-text" :label="!isSmallerScreen ? 'Documents' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-documents />
          </div>
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Subscription' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-subscripiton />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import OrgSettingsAccount from "./OrgSettingsAccount.vue";
import OrgSettingsAdmins from "./OrgSettingsAdmins.vue";
import OrgSettingsConfig from "./OrgSettingsConfig.vue";
import OrgSettingsEvaluate from "./OrgSettingsEvaluate.vue";
import OrgSettingsDocuments from "./OrgSettingsDocuments.vue"; // NEW IMPORT
import OrgSubscripiton from "./Subscription.vue";

// If you still need the others, keep them imported, I removed the unused ones for brevity

export default {
  components: {
    OrgSettingsAccount,
    OrgSettingsAdmins,
    OrgSettingsConfig,
    OrgSettingsEvaluate,
    OrgSettingsDocuments, // NEW REGISTRATION
    OrgSubscripiton
  },
  data() {
    return {
      activeTab: 0,
      isEvaluateDirty: false,
      isCriteriaDirty: false,
      isSwitchingTabProgrammatically: false
    };
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    }
  },
  watch: {
    activeTab(newVal, oldVal) {
      if (this.isSwitchingTabProgrammatically) return;

      if (oldVal === 3 && this.isEvaluateDirty) {
        this.isSwitchingTabProgrammatically = true;
        this.activeTab = oldVal;
        
        this.$nextTick(() => {
          this.isSwitchingTabProgrammatically = false;
        });

        if (this.$refs.evaluatePage) {
          this.$refs.evaluatePage.triggerUnsavedPopup(newVal);
        }
        return;
      }
    }
  },
  methods: {
    handleDirtyStateChanged(isDirty) {
      this.isEvaluateDirty = isDirty;
    },
    handleProceedToTab(targetTabIndex) {
      this.isSwitchingTabProgrammatically = true;
      this.activeTab = targetTabIndex;
      this.$nextTick(() => {
        this.isSwitchingTabProgrammatically = false;
      });
    }
  },
};
</script>

<style scoped lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>